<template>
  <div class="study_article_manage">
    <el-divider content-position="left">常见问题</el-divider>
    <el-button
      type="primary"
      size="mini"
      @click="handleAddOpen"
      style="margin-bottom: 0.2rem"
      >添加</el-button
    >
    <el-table height="calc(100vh - 266px)" :data="pageData" size="medium" style="width: 100%" border>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
      >
      </el-table-column>
      <el-table-column label="视频">
        <template slot-scope="scope">
          <span
            @click="handlePictureCardPreviewVideo(scope.row.video_url)"
            style="color: #409eff; cursor: pointer"
            >{{ scope.row.video_url }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="是否显示文章">
        <template slot-scope="scope">
          {{ scope.row.is_show === "1" ? "显示" : "隐藏" }}
        </template>
      </el-table-column>
      <el-table-column label="是否显示轮播图">
        <template slot-scope="scope">
          {{ scope.row.is_banner === "1" ? "显示" : "隐藏" }}
        </template>
      </el-table-column>
      <el-table-column label="分类">
        <template slot-scope="scope">
          {{ getCateName(scope.row.cate_id) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140">
        <template slot-scope="scope">
          <!-- {{scope.row.created_at}} -->
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            v-if="false"
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.id)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="添加问题"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleAddDrawerClose"
      size="50%"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/article/banner/upload'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleAddCoverSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="addCoverUrl" :src="addCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-input
            placeholder="请输入标题"
            v-model="addData.problem_title"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row>
          <el-select
            v-model="addData.cate_id"
            filterable
            size="small"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in selOptions"
              :key="item.cate_id"
              :label="item.cate_name"
              :value="item.cate_id"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <!--          <el-col :span="2"   class="tr m-label text_right">选择要必读的人员</el-col>-->
          <el-col :span="24">
            <el-select
              :filterable="true"
              multiple
              collapse-tags
              v-model="addData.uid"
              placeholder="请选择要必读的人"
              size="small"
              clearable
            >
              <el-option
                v-for="(item, index) in ConversionPeople"
                :key="index"
                :label="item.username"
                :value="item.uid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-upload
              class="upload-demo"
              :action="actionHost + '/api/study/upload_video'"
              :headers="uploadHeader"
              accept="MP4"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :file-list="fileListMp4"
            >
              <el-button v-if="!addVideo_url" size="mini" type="primary"
                >点击上传视频</el-button
              >
            </el-upload>
          </el-col>
        </el-row>
        <el-row>
          <span class="span_pd">是否显示文章</span>
          <el-tooltip
            :content="'Switch value: ' + addData.problem_status"
            placement="top"
          >
            <el-switch
              v-model="addData.problem_status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </el-tooltip>
        </el-row>
        <el-row>
          <span class="span_pd">是否显示轮播图</span>
          <el-tooltip
            :content="'Switch value: ' + addData.problem_status_banner"
            placement="top"
          >
            <el-switch
              v-model="addData.problem_status_banner"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </el-tooltip>
        </el-row>
        <vue-ueditor-wrap
          v-model="addData.problem_content"
          :config="myConfig"
        ></vue-ueditor-wrap>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleAdd">添加</el-button>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑问题"
      :visible.sync="editDrawer"
      :direction="direction"
      :before-close="handleEditDrawerClose"
      size="50%"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/article/banner/upload'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleEditCoverSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="editCoverUrl" :src="editCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-input
            placeholder="请输入标题"
            v-model="saveData.problem_title"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row>
          <el-select
            v-model="saveData.cate_id"
            filterable
            size="small"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in selOptions"
              :key="item.cate_id"
              :label="item.cate_name"
              :value="item.cate_id"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <!--          <el-col :span="2"   class="tr m-label text_right">选择要必读的人员</el-col>-->
          <el-col :span="24">
            <el-select
              :filterable="true"
              multiple
              collapse-tags
              v-model="saveData.uid"
              placeholder="请选择要必读的人"
              size="small"
              clearable
            >
              <el-option
                v-for="(item, index) in ConversionPeople"
                :key="index"
                :label="item.username"
                :value="item.uid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-upload
              class="upload-demo"
              :action="actionHost + '/api/study/upload_video'"
              :headers="uploadHeader"
              accept="mp4,MP4"
              :on-preview="handlePreviewSave"
              :on-remove="handleRemoveSave"
              :on-success="handleSuccessSave"
              :before-remove="beforeRemoveSave"
              multiple
              :limit="1"
              :file-list="fileListSaveMp4"
            >
              <el-button v-if="!SaveVideo_url" size="mini" type="primary"
                >点击上传视频</el-button
              >
              <!--              <video v-if="SaveVideo_url" :src="SaveVideo_url"></video>-->
            </el-upload>
          </el-col>
        </el-row>
        <el-row>
          <span class="span_pd">是否显示文章</span>
          <el-tooltip
            :content="'Switch value: ' + saveData.problem_status"
            placement="top"
          >
            <el-switch
              v-model="saveData.problem_status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </el-tooltip>
        </el-row>
        <el-row>
          <span class="span_pd">是否显示轮播图</span>
          <el-tooltip
            :content="'Switch value: ' + saveData.problem_status_banner"
            placement="top"
          >
            <el-switch
              v-model="saveData.problem_status_banner"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </el-tooltip>
        </el-row>
        <vue-ueditor-wrap
          v-model="saveData.problem_content"
          :config="myConfig"
        ></vue-ueditor-wrap>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
    <el-dialog width="40%" :visible.sync="dialogVisibleShowVideo">
      <video controls width="100%" :src="dialogVideoUrl"></video>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import DateFormatter from "common/DateFormatter";
export default {
  name: "study_article_manage",
  components: {
    VueUeditorWrap,
    DateFormatter,
  },
  data() {
    return {
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      StudyList: [],
      selOptions: [],
      ConversionPeople: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      col: [
        {
          label: "id",
          prop: "id",
        },
        {
          label: "标题",
          prop: "title",
        },
      ],
      direction: "rtl",
      addDrawer: false,
      addCoverUrl: "",
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        initialFrameWidth: "100%",
        serverUrl: this.$store.state.serverUrlStudy,
        zIndex: 9999,
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "paragraph",
            "fontfamily",
            "fontsize",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "indent",
            "|",
            "touppercase",
            "tolowercase",
            "imageleft",
            "imageright",
            "imagecenter",
            "simpleupload",
            "emotion",
            "preview",
          ],
        ],
      },
      addData: {
        cover: "",
        cate_id: null,
        problem_title: "",
        problem_content: "",
        problem_status: "1",
        problem_status_banner: "2",
        uid: "",
        video_url: "",
      },
      editDrawer: false,
      editCoverUrl: "",
      saveData: {
        id: null,
        index: null,
        cover: "",
        cate_id: null,
        problem_title: "",
        problem_content: "",
        problem_status: "1",
        problem_status_banner: "1",
        uid: "",
        video_url: "",
      },
      fileListMp4: [],
      fileListSaveMp4: [],
      addVideo_url: "",
      SaveVideo_url: "",
      dialogVideoUrl: "",
      dialogVisibleShowVideo: false,
    };
  },
  computed: {
    actionHost: {
      get: function () {
        // http://192.168.1.110
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    pageData: {
      get: function () {
        return this.StudyList.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    handlePictureCardPreviewVideo(url) {
      this.dialogVideoUrl = url;
      this.dialogVisibleShowVideo = true;
    },
    handleSuccess(res, file) {
      this.addVideo_url = URL.createObjectURL(file.raw);
      if (res.code === 0) {
        this.fileListMp4.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
          img_name: res.data.store_result,
        });
        console.log(res.data.store_result);
        this.addData.video_url = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      if (file.name === this.fileListMp4[0].name) {
        var fileName = this.fileListMp4[0].img_name;
        this.addVideo_url = "";
        this.addData.video_url = "";
        this.fileListMp4 = [];
      }
      this.$axios.post("/api/study/del_video", { file_name: fileName }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handlePreview(file) {
      this.dialogVideoUrl = file.url;
      this.dialogVisibleShowVideo = true;
      // console.log(file)
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }?`)
    },
    handleSuccessSave(res, file) {
      this.SaveVideo_url = URL.createObjectURL(file.raw);
      if (res.code === 0) {
        this.fileListSaveMp4.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
          img_name: res.data.store_result,
        });
        this.saveData.video_url = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleRemoveSave(file, fileList) {
      if (file.name === this.fileListSaveMp4[0].name) {
        var fileName = this.fileListSaveMp4[0].img_name;
        this.saveData.video_url = "";
        this.SaveVideo_url = "";
        this.StudyList[this.saveData.index].video_url = "";
        this.fileListSaveMp4 = [];
      }
      this.$axios.post("/api/study/del_video", { file_name: fileName }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handlePreviewSave(file) {
      this.dialogVideoUrl = file.url;
      this.dialogVisibleShowVideo = true;
      // window.open(file.url)
    },
    beforeRemoveSave(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }?`)
    },
    getProblemData() {
      this.$axios.get("/api/article/article_list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.StudyList = data.data.list;
          this.ConversionPeople = data.data.users;
          this.pageOption.total = this.StudyList.length;
          this.selOptions = data.data.cates;
        }
      });
    },
    getCaption(obj, state) {
      var index = obj.lastIndexOf("storage/");
      console.log(index);
      if (state === 0) {
        obj = obj.substring(0, index);
      } else {
        obj = obj.substring(index + 1, obj.length);
      }
      return obj;
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleAddDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => {});
    },
    handleAddOpen() {
      this.addDrawer = true;
    },
    handleAddCoverSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        this.addData.cover = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }
      return true;
    },
    handleAdd() {
      if (!this.addData.problem_title) {
        this.$message.error("标题不能为空");
        return;
      }
      if (!this.addData.cate_id) {
        this.$message.error("请选择分类");
        return;
      }
      if (!this.addData.problem_content) {
        this.$message.error("内容不能为空");
        return;
      }
      // console.log(this.addData)
      this.$axios
        .post("/api/article/create", {
          cate_id: this.addData.cate_id,
          image: this.addData.cover,
          title: this.addData.problem_title,
          is_show: this.addData.problem_status,
          is_banner: this.addData.problem_status_banner,
          contents: this.addData.problem_content,
          read_ids: this.addData.uid,
          video_url: this.addData.video_url,
        })
        .then((res) => {
          // console.log(res)
          const { data } = res;
          if (data.code === 0) {
            this.StudyList.unshift(data.data);
            this.pageOption.total = this.StudyList.length;
            this.$message.success(data.msg);
            this.clearAddData();
            this.addDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEdit(index, row) {
      this.saveData.id = row.id;
      this.saveData.index = index;
      this.saveData.cate_id = row.cate_id;
      // console.log(row.image)
      // console.log(this.imgPath)
      this.saveData.cover = row.image;
      this.saveData.video_url = row.video_url;
      this.editCoverUrl = row.image;
      this.SaveVideo_url = row.video_url;
      if (row.video_url) {
        this.fileListSaveMp4.push({
          name: row.video_url,
          url: row.video_url,
          img_name: row.video_url,
        });
      }
      // console.log(row.video_url)
      this.saveData.problem_title = row.title;
      this.saveData.problem_status = row.is_show;
      this.saveData.problem_status_banner = row.is_banner;
      this.saveData.problem_content = row.contents;
      this.saveData.uid = row.read_ids;
      this.editDrawer = true;
    },
    handleEditCoverSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.saveData.cover = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEditDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    handleSave() {
      if (!this.saveData.id) {
        this.$message.error("请求错误");
        return;
      }
      if (this.saveData.index === null) {
        this.$message.error("请求错误");
        return;
      }

      if (!this.saveData.cate_id) {
        this.$message.error("请求错误");
        return;
      }
      if (!this.saveData.problem_title) {
        this.$message.error("标题不能为空");
        return;
      }
      if (!this.saveData.problem_content) {
        this.$message.error("内容不能为空");
        return;
      }
      this.$axios
        .post("/api/article/update/" + this.saveData.id, {
          cate_id: this.saveData.cate_id,
          image: this.saveData.cover,
          title: this.saveData.problem_title,
          contents: this.saveData.problem_content,
          read_ids: this.saveData.uid,
          is_show: this.saveData.problem_status,
          is_banner: this.saveData.problem_status_banner,
          video_url: this.saveData.video_url,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let index =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.saveData.index;
            this.StudyList[index].image = this.saveData.cover;
            this.StudyList[index].cate_id = this.saveData.cate_id;
            this.StudyList[index].title = this.saveData.problem_title;
            this.StudyList[index].contents = this.saveData.problem_content;
            this.StudyList[index].is_show = this.saveData.problem_status;
            this.StudyList[index].is_banner = this.saveData.problem_status_banner;
            this.StudyList[index].video_url = this.saveData.video_url;
            this.$message.success(data.msg);
            this.clearSaveData();
            this.editDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleDelete(index, id) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDeleteSub(index, id);
        })
        .catch(() => {});
    },
    handleDeleteSub(index, id) {
      this.$axios.post("/api/admin/problem/del", { id }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.problem.splice(idx, 1);
          this.pageOption.total = this.problem.length;
          if (index === 0) this.prePage();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    clearAddData() {
      this.addData.cate_id = null;
      this.addCoverUrl = "";
      this.addData.cover = "";
      this.addData.problem_title = "";
      this.addData.problem_status = "1";
      this.addData.problem_status_banner = "2";
      this.addData.problem_content = "";
      this.addData.uid = "";
      this.fileListMp4 = [];
    },
    clearSaveData() {
      this.saveData.id = null;
      this.saveData.index = null;
      this.saveData.cate_id = null;
      this.saveData.cover = "";
      this.editCoverUrl = "";
      this.saveData.problem_title = "";
      this.saveData.problem_status = "1";
      this.saveData.problem_status_banner = "1";
      this.saveData.problem_content = "";
      this.saveData.uid = "";
      this.fileListSaveMp4 = [];
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    getCateName(id) {
      for (var i = 0; i < this.selOptions.length; i++) {
        if (this.selOptions[i].cate_id === id) return this.selOptions[i].cate_name;
      }
    },
  },
  mounted() {
    this.getProblemData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.study_article_manage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.study_article_manage
  marginLeft()
.el-dialog__wrapper >>> .el-drawer
  overflow-y: auto
.m-tabs-content
  padding: 0 .2rem 0 .4rem
.addCon
  margin: .2rem 0
  text-align: right
.el-row
  margin-bottom: .2rem
.el-select
  width: 100%
.avatar-uploader
  text-align: center
  margin-bottom: .2rem
.avatar-uploader >>> .el-upload
  border: .02rem dashed #d9d9d9
  border-radius: .12rem
  cursor: pointer
  position: relative
  overflow: hidden
.avatar-uploader >>> .el-upload:hover
  border-color: #409eff
.avatar-uploader >>> .el-upload img
  width: 4rem
  height: 2rem
.avatar-uploader-icon
  font-size: .4rem
  color: #8c939d
  width: 4rem
  height: 2rem
  line-height: 2rem
  text-align: center
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/studyPlatfrom/study_article_manage.vue